import { Tabs, Tab, Select, MenuItem, Icon, LinearProgress, Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import yellow from '@material-ui/core/colors/yellow';
import Warning from '@material-ui/icons/Warning';
import React, { PureComponent } from 'react';

const styles = {
    environmentValue: {
        display: 'flex',
        alignItems: 'center'
    },
    environmentIcon: {
        paddingRight: '8px'
    },
    tabsRoot: {
        'alignSelf': 'flex-end',
        color: '#fff'
    },
    tabsIndicator: {
        backgroundColor: '#fff',
    },
    progressColorPrimary: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)'
    },
    progressBarColorPrimary: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    }
};

class Header extends PureComponent {
    render() {
        return (
            <div className="header">
                <div className="sidebar-logo">
                    <strong>devops</strong>.picker.
                </div>
                <Tabs
                    classes={{
                        root: this.props.classes.tabsRoot,
                        indicator: this.props.classes.tabsIndicator
                    }}
                    value={this.props.tab}
                    onChange={this.props.onChangeTab}>
                    <Tab label="Query" />
                    <Tab label="Schema" />
                </Tabs>
                <Select onChange={this.props.onChangeEnvironment}
                        value={this.props.environment}
                        renderValue={this._renderEnvironmentValue}
                        style={{ margin: '0 16px' }}>
                    <MenuItem value="local">localhost</MenuItem>
                    <MenuItem value="staging">staging</MenuItem>
                    <MenuItem value="live">live</MenuItem>
                </Select>
                <Button onClick={this.props.onRefetchSchema} disabled={this.props.fetchingSchema}>RELOAD SCHEMA</Button>
                {this.props.fetchingSchema && (
                    <div style={{ display: 'flex', flexFlow: 'column nowrap', alignItems: 'stretch', marginLeft: '8px' }}>
                        <Typography color="textSecondary" variant="body1" gutterBottom>Fetching schema</Typography>
                        <LinearProgress variant="query" classes={{
                            colorPrimary: this.props.classes.progressColorPrimary,
                            barColorPrimary: this.props.classes.progressBarColorPrimary
                        }} />
                    </div>
                )}
                {this.props.errorFetchingSchema && (
                    <div style={{ display: 'flex', flexFlow: 'row nowrap', alignItems: 'center', marginLeft: '8px'}}>
                        <Warning style={{ color: yellow.A100 }} />
                        <Typography variant="body1" style={{ margin: '0 8px', color: yellow.A100 }}>Failed to fetch schema</Typography>
                    </div>
                )}
            </div>
        );
    }

    _renderEnvironmentValue = (value) => {
        return (
            <div className={this.props.classes.environmentValue}>
                <Icon classes={{root: this.props.classes.environmentIcon}}>settings_ethernet</Icon>
                {value}
            </div>
        );
    };
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js